import React from 'react';
import BaseComponent from '../system/base';
import PropTypes from 'prop-types';

class Popup extends BaseComponent {

  constructor(props, context) {
    super(props, context);
    this.state = {
      open: this.props.open
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.open !== nextProps.open) {
      this.setState({open:nextProps.open});
    }
  }

  render() {
    return (
      <div>
        <div className={"md-modal " + this.props.classModal + " " + (this.state.open ? "md-show": "")}>
          <div className="md-content">
            {this.props.children}
          </div>
        </div>
        {this.state.open && <div className="md-overlay" onClick={() => {
          if (this.props.closeOnOverlayClick) {
            this.setState({open: false})
          }
          if (this.props.hasOwnProperty("onClickOverlay")) {
            this.props.onClickOverlay();
          }
        }}></div>}
      </div>
    );
  }
}

Popup.propTypes = {
  onClickOverlay : PropTypes.func,
  classModal : PropTypes.string,
  open : PropTypes.bool,
};

Popup.defaultProps = {
  classModal: "md-effect-13",
  closeOnOverlayClick: true,
};

export default Popup


// WEBPACK FOOTER //
// ./src/components/popup/index.js